export default "__VITE_ASSET__BdHAmsVo__"